<button [class]="buttonClasses" (click)="onClick()" [disabled]="disabled || waiting" [style.height]="height">
    {{ text }}
    <span *ngIf="showSpinnerDelayed$ | async">
        <i-lucide name="loader" size="20" strokeWidth="2" class="spinner ml-2"></i-lucide>
    </span>
</button>